import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-we-work',
  templateUrl: './how-we-work.component.html',
  styleUrls: ['./how-we-work.component.css']
})
export class HowWeWorkComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/how-we-work/how-we-work.component.ts